import { makeStyles } from 'tss-react/mui'
import PageMetaData, { BUTTON_SIZE } from '@v4/utils/data/PageMetaData'
import { getDirectionValue } from '@v4/utils/theme'

const useStyles = makeStyles()(
	(
		theme,
		{
			backgroundImagePosition,
			opacity,
			mobileOpacity,
			direction,
			mobileAlignment,
			mobileImagePosition,
			mobileButtonWidth,
		},
	) => ({
		root: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		background: {
			display: 'none',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			maxWidth: '100%',
			overflow: 'hidden',
			backgroundPositionY: backgroundImagePosition || 'center',
			backgroundPositionX: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			'&:after': {
				content: '""',
				transition: theme.transitions.create('opacity'),
				backgroundColor: 'black',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: (opacity || 0) / 100,

				[theme.breakpoints.down('md')]: {
					opacity: (mobileOpacity || 0) / 100,
				},
			},
		},
		backgroundDesktop: {
			[theme.breakpoints.up('md')]: {
				display: 'block',
			},
		},
		backgroundMobile: {
			[theme.breakpoints.down('md')]: {
				display: 'block',
			},
		},
		grid: {
			zIndex: 2,
			marginLeft: 'auto',
			marginRight: 'auto',
			display: 'flex',
			[theme.breakpoints.down('md')]: {
				flexGrow: 1,
				order: getDirectionValue(direction, { desc: 2 }),
			},
		},
		content: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'stretch',
			width: '100%',
		},

		text: {
			[theme.breakpoints.down('md')]: {
				'& *': {
					textAlign: mobileAlignment ? `${mobileAlignment} !important` : null,
				},
			},
		},

		mobileImageWrapper: {
			marginLeft: theme.spacing(-2),
			marginRight: theme.spacing(-2),
			transition: theme.transitions.create(['margin-top', 'margin-bottom']),
			marginTop: mobileImagePosition === PageMetaData.ALIGNMENT.RIGHT ? theme.spacing(3) : null,
			marginBottom: mobileImagePosition === PageMetaData.ALIGNMENT.LEFT ? theme.spacing(3) : null,
		},

		mobileImage: {
			width: '100%',

			'& picture': {
				width: '100%',
			},
			'& img': {
				width: '100%',
				objectFit: 'contain',
			},
		},

		actionContainer: {
			[theme.breakpoints.down('md')]: {
				justifyContent: PageMetaData.CONTENT_ALIGNMENT[mobileAlignment] || null,
			},
		},

		button: {
			minWidth: theme.spacing(44.5),

			[theme.breakpoints.down('md')]: {
				minWidth: 'auto',
				width: mobileButtonWidth === BUTTON_SIZE.WIDE ? '100%' : 'auto',
			},
		},

		mobileImageGrid: {
			display: 'none',

			[theme.breakpoints.down('md')]: {
				display: 'block',
				order: getDirectionValue(direction, { desc: 1 }, 2),
			},
		},
	}),
)

export default useStyles
